export default __webpack_public_path__ + "img/breadcrumbs.bedf40d8.svg";